import {
  Box,
  Chip,
  ListItemButton,
  Stack,
  Typography,
} from "@mui/material";

function NotificationListItem({
  notification,
  compact = false,
  onClick,
  selected = false,
}) {
  return (
    <ListItemButton
      onClick={onClick}
      selected={selected}
      disabled={!onClick}
      sx={{
        alignItems: "flex-start",
        borderRadius: 3,
        px: compact ? 1.5 : 2,
        py: compact ? 1.25 : 1.75,
        mb: 1,
        border: "1px solid rgba(15, 23, 42, 0.06)",
        bgcolor: notification.unread ? "#eff6ff" : "white",
        "&.Mui-selected": {
          bgcolor: "#dbeafe",
        },
        "&:hover": {
          bgcolor: notification.unread ? "#dbeafe" : "#f8fafc",
        },
        "&.Mui-disabled": {
          opacity: 1,
        },
      }}
    >
      <Stack spacing={1} sx={{ width: "100%" }}>
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <Typography
              variant={compact ? "body2" : "subtitle1"}
              fontWeight={700}
              color="#0f172a"
            >
              {notification.title}
            </Typography>
            {notification.unread ? (
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  bgcolor: "#2563eb",
                  flexShrink: 0,
                }}
              />
            ) : null}
          </Stack>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ flexShrink: 0 }}
          >
            {notification.time}
          </Typography>
        </Stack>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            lineHeight: 1.6,
            display: "-webkit-box",
            WebkitLineClamp: compact ? 2 : 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {notification.message}
        </Typography>

        <Box>
          <Chip
            label={notification.category}
            size="small"
            sx={{
              bgcolor: "rgba(37, 99, 235, 0.08)",
              color: "#1d4ed8",
              fontWeight: 700,
            }}
          />
        </Box>
      </Stack>
    </ListItemButton>
  );
}

export default NotificationListItem;
